import * as types from './actionTypes';
import Resource from "../services/PrivateAPIResource";

export function createArticleSuccess(article) {
    return {type: types.CREATE_ARTICLE_SUCCESS, article};
}

export function loadArticlesSuccess(articles) {
    return {type: types.LOAD_ARTICLES_SUCCESS, articles};
}

export function getArticleSuccess(article) {
    return {type: types.GET_ARTICLE_SUCCESS, article};
}

export function deleteArticleSuccess(id) {
    return {type: types.DELETE_ARTICLE_SUCCESS, id};
}

export function cloneArticleSuccess(article) {
    return {type: types.CLONE_ARTICLE_SUCCESS, article};
}

export function resetArticle() {
    return { type: types.RESET_ARTICLE };
}

export function getArticle(id) {
    return function (dispatch) {
        return Resource.get('articles', id).then(article => {
            dispatch(getArticleSuccess(article))
        }).catch(error => {
            throw error;
        });
    }
}

export function loadArticles(page, sortParams) {
    console.log(sortParams);
    return function (dispatch) {
        return Resource.all('articles?page='+page, sortParams).then(articles => {
            dispatch(loadArticlesSuccess(articles))
        }).catch(error => {
            throw error;
        });
    }
}

export function saveArticle(article) {
    return function (dispatch, getState) {
        return Resource.create('articles', article, true).then(article => {
            dispatch(createArticleSuccess(article));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateArticleVimeo(id, data) {
    return function (dispatch, getState) {
        return Resource.update(`articles/${id}`, 'vimeo', data).then(article => {
            dispatch(createArticleSuccess(article));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateArticle(article, id) {
    return function (dispatch, getState) {
        return Resource.update('articles', id, article, true).then(article => {
            dispatch(createArticleSuccess(article));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteArticle(id) {
    return function (dispatch) {
        return Resource.remove('articles', id).then(() => {
            dispatch(deleteArticleSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function cloneArticle(id) {
    return function (dispatch) {
        return Resource.get('articles/clone', id).then(article => {
            dispatch(cloneArticleSuccess(article))
        }).catch(error => {
            throw  error;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/articleActions.js